import React from 'react';
import './index.less';
export default function TabHeader(props) {
    const { tab } = props;
    return (<div className="zhuge-tab-nav-header">
      <div>
        
        <img className="zhuge-tab-default-logo" src={tab.logo} alt=""/>
        <img className="zhuge-tab-active-logo" src={tab.picklogo} alt=""/>
      </div>

      <div>{tab.title}</div>
    </div>);
}
